<div class="d-flex justify-content-start add-menu" [class.open]="menuOpen" [style.opacity]="opacity$ | async">
    <app-icon class="se-icon-button no-bg add-icon no-hover" src="plus-round"></app-icon>
</div>
